const translations = {
  es: {
    credentialPage: {
      documentTitle: "Certificación Immunotec - {name}",
      pageTitle: "Certificación en Immunocal - Líder Certificado",
      issuedTo: "Emitido a",
      consultantId: "ID del Consultor",
      badgeId: "ID de Insignia",
      title: "Título",
      company: "Compañía",
      issuedBy: "Emitido por",
      location: "Ubicación",
      issueDate: "Fecha de Emisión",
      expirationDate: "Fecha de Expiración",
      permanent: "Permanente",
      description: "Descripción",
    },
    errorPage: {
      documentTitle: "Certificación No Encontrada - Immunotec",
      title: "Certificación No Encontrada",
      message:
        "El enlace de certificación al que intentó acceder es inválido o no existe. Por favor verifique la URL o contacte a Immunotec para obtener ayuda.",
      returnHome: "Volver al sitio de Immunotec",
      contactSupport: "Contactar Soporte",
    },
  },
  en: {
    credentialPage: {
      documentTitle: "Immunotec Certification - {name}",
      pageTitle: "Immunocal Certification - Certified Leader",
      issuedTo: "Issued to",
      consultantId: "Consultant ID",
      badgeId: "Badge ID",
      title: "Title",
      company: "Company",
      issuedBy: "Issued By",
      location: "Location",
      issueDate: "Issue Date",
      expirationDate: "Expiration Date",
      permanent: "Permanent",
      description: "Description",
    },
    errorPage: {
      documentTitle: "Certification Not Found - Immunotec",
      title: "Certification Not Found",
      message:
        "The certification link you accessed is invalid or does not exist. Please verify the URL or contact Immunotec for assistance.",
      returnHome: "Return to Immunotec Website",
      contactSupport: "Contact Support",
    },
  },
};

export const getTranslation = (lang = "es") => {
  return translations[lang] || translations.es;
};

export default translations;
